export var TipRoutes;
(function (TipRoutes) {
    TipRoutes["TipCompact"] = "tip-compact";
    TipRoutes["TipNormal"] = "tip-normal";
    TipRoutes["TipStatus"] = "tip-status";
    TipRoutes["TipModal"] = "tip-modal";
})(TipRoutes || (TipRoutes = {}));
